import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  CircularProgress,
  Alert,
  Collapse,
  Button,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { fetchPackages } from '../../features/packages/packagesSlice';
import PackageFilters from '../../components/client/PackageFilters';
import PackageCard from '../../components/client/PackageCard';
import HeroBanner from '../../components/client/HeroBanner';
import AdBanner from '../../components/client/AdBanner';

const HomePage = () => {
  const dispatch = useDispatch();
  const { packages, isLoading, error, meta } = useSelector((state) => state.packages);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    company: '',
    departureCity: '',
    minPrice: '',
    maxPrice: '',
    duration: '',
    category: '',
    zone: '',
    availability: false,
    page: 1,
    limit: 9,
  });

  useEffect(() => {
    dispatch(fetchPackages(filters));
  }, [dispatch, filters]);

  const handleFilterChange = (newFilters) => {
    setFilters({ ...filters, ...newFilters, page: 1 });
  };

  const handlePageChange = (event, value) => {
    setFilters({ ...filters, page: value });
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const clearFilters = () => {
    setFilters({
      company: '',
      departureCity: '',
      minPrice: '',
      maxPrice: '',
      duration: '',
      category: '',
      zone: '',
      availability: false,
      page: 1,
      limit: 9,
    });
  };

  return (
    <Box>
      {/* Bannière héro */}
      <HeroBanner />
      
      {/* Bannière publicitaire */}
      <Box sx={{ my: 2 }}>
        <AdBanner />
      </Box>
      
      {/* Titre principal */}
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Forfaits Hajj disponibles
        </Typography>
        <Button
          variant="outlined"
          startIcon={<FilterListIcon />}
          onClick={toggleFilters}
        >
          {showFilters ? 'Masquer les filtres' : 'Afficher les filtres'}
        </Button>
      </Box>
      
      {/* Message d'erreur */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      {/* Section de contenu principal */}
      <Grid container spacing={3}>
        {/* Filtres */}
        <Grid item xs={12} md={3}>
          <Collapse in={showFilters} timeout="auto" unmountOnExit>
            <Paper sx={{ p: 2, mb: { xs: 2, md: 0 } }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Filtres
                </Typography>
                <Button size="small" onClick={clearFilters}>
                  Réinitialiser
                </Button>
              </Box>
              <Divider sx={{ mb: 2 }} />
              <PackageFilters onFilterChange={handleFilterChange} filters={filters} />
            </Paper>
          </Collapse>
        </Grid>
        
        {/* Liste des forfaits */}
        <Grid item xs={12} md={showFilters ? 9 : 12}>
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
              <CircularProgress />
            </Box>
          ) : packages.length === 0 ? (
            <Paper sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h6" color="text.secondary">
                Aucun forfait ne correspond à votre recherche
              </Typography>
              <Button variant="text" onClick={clearFilters} sx={{ mt: 2 }}>
                Réinitialiser les filtres
              </Button>
            </Paper>
          ) : (
            <>
              <Grid container spacing={3}>
                {packages.map((pkg) => (
                  <Grid item xs={12} sm={6} md={4} key={pkg._id}>
                    <PackageCard package={pkg} />
                  </Grid>
                ))}
              </Grid>
              
              {/* Pagination */}
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                {/* Pagination Component will be added here */}
              </Box>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomePage;

